"use client";
import { useState } from "react";
import ResToggle from "./resToggle";
import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { isSDXL } from "../../shared/generators/isSDXL";
import { useGenerator } from "@/app/context/GeneratorContext";

export default function ResToggleSet({ type, translations }: { type: string; translations: any }) {
  const { state } = useGenerator();
  const [open, setOpen] = useState(0);

  const handleOpen = (value: any) => {
    setOpen(open === value ? 0 : value);
  };

  let ponyResolutions = [
    { value: 10, string: "2:3" },
    { value: 11, string: "3:2" },
    { value: 7, string: "1:1" },
    { value: 8, string: "⟡ 3:4" },
    { value: 9, string: "⟡ 4:3" },
  ]; //, { value: 12, string: "⟡ 16:9" }
  let resolutions = [
    { value: 1, string: "2:3" },
    { value: 2, string: "3:2" },
    { value: 3, string: "1:1" },
    { value: 4, string: "⟡ 3:4" },
    { value: 5, string: "⟡ 4:3" },
    { value: 6, string: "⟡ 16:9" },
  ];
  let gifResolutions = [{ string: "2:3" }, { string: "3:2" }];

  // @ts-ignore
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    );
  }

  return (
    <Accordion
      open={open === 1}
      icon={<Icon id={1} open={open} />}
      className="border-t-[0.5px] border-[#3C3C3C] bg-[#2B2D31] px-2 pt-2 md:px-4"
    >
      <AccordionHeader
        onClick={() => handleOpen(1)}
        className={`border-b-0 px-[4px] pb-4 pt-2 text-sm text-white sm:px-0 ${
          open === 1 ? "text-white hover:!text-white" : ""
        }`}
      >
        {translations.aspectRatio}
      </AccordionHeader>
      <AccordionBody className="pb-2 pt-0 text-base font-normal">
        {type === "image" && !isSDXL(state.selectedGenerator.shortName || "style") && (
          <div>
            {resolutions.map(function (toggle: any, i: any) {
              return <ResToggle key={i} toggle={toggle} type={type} translations={translations} />;
            })}
          </div>
        )}
        {type === "image" && isSDXL(state.selectedGenerator.shortName || "style") && (
          <div>
            {ponyResolutions.map(function (toggle: any, i: any) {
              return <ResToggle key={i} toggle={toggle} type={type} translations={translations} />;
            })}
          </div>
        )}
        {type === "gif" && (
          <div>
            {gifResolutions.map(function (toggle: any, i: any) {
              return <ResToggle key={i} toggle={toggle} type={type} translations={translations} />;
            })}
          </div>
        )}
      </AccordionBody>
    </Accordion>
  );
}
